/*
  Saint Esen: "Add to cart" goes straight to checkout (Alex, 2026-10-21).

  How it fits together
  - snippets/se-direct-checkout.liquid holds the ON/OFF switch and loads this file (never in the
    theme editor).
  - deploy.py patches Dawn's assets/product-form.js (DAWN_PATCHES) so that, after a SUCCESSFUL
    add, it calls window.seDirectCheckout.go(form). Every add-to-cart on the site runs through
    product-form.js: the product page form, the sticky bar (it submits that same form), the
    homepage featured product, and quick add if it is ever turned on.
  - A failed add never reaches this file: Dawn's own error branch runs first and shows its message
    as usual.
  - If this file is switched off or fails to load, window.seDirectCheckout is undefined and Dawn
    does exactly what it did before (the cart popup).

  go(form) returns true once it has started a navigation (checkout, or the cart page as a
  fallback); Dawn then stops and leaves its button spinning so a second tap can't add a second
  swing. It returns false only if it could not navigate at all, and Dawn falls back to its normal
  cart popup. Never a dead button.
*/
(function () {
  'use strict';

  var CHECKOUT_URL = '/checkout';
  // If the browser still hasn't left this page this long after we sent it to checkout, the
  // navigation was blocked or dropped: send the shopper to the cart page, which shows the item
  // and its own checkout button.
  var FALLBACK_MS = 10000;
  var fallbackTimer = null;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  // The shopper pressed Back from checkout and the browser restored this page from its
  // back/forward cache: put the button back the way Dawn leaves it after an add.
  function resetForm(form) {
    try {
      form.seLeaving = false;
      var btn = form.submitButton;
      if (btn) {
        btn.classList.remove('loading');
        if (!form.error) btn.removeAttribute('aria-disabled');
      }
      var spinner = form.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    } catch (e) {
      /* nothing else to do */
    }
  }

  // Same refresh Dawn's cart popup does, so the header cart count is right after Back.
  function refreshCartBubble() {
    try {
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !window.fetch || !window.DOMParser) return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections && sections['cart-icon-bubble'];
          if (!html) return;
          var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        })
        .catch(function () {});
    } catch (e) {
      /* the count fixes itself on the next page load */
    }
  }

  function go(form) {
    try {
      if (fallbackTimer) clearTimeout(fallbackTimer);
      fallbackTimer = setTimeout(function () {
        window.location.assign(cartUrl());
      }, FALLBACK_MS);
      // pagehide = the browser is really leaving (or freezing this page in its cache): no fallback.
      window.addEventListener('pagehide', function () {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }, { once: true });
      window.addEventListener('pageshow', function (evt) {
        if (!evt.persisted) return;
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
        resetForm(form);
        refreshCartBubble();
      }, { once: true });
      window.location.assign(CHECKOUT_URL);
      return true;
    } catch (e) {
      try {
        window.location.assign(cartUrl());
        return true;
      } catch (e2) {
        return false;
      }
    }
  }

  window.seDirectCheckout = { go: go };
})();
